import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {L10nModule} from '../../../components/translate';
import {ChartSecurityInputComponent} from './chart-security-input.component';
import {SecurityAutocompleteListModComponent} from './security-input-mod/security-autocomplete-list-mod.component';
import {SecurityAutocompleteModDirective} from './security-input-mod/security-autocomplete-mod.directive';
import {SecurityInputModComponent} from './security-input-mod/security-input-mod.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        L10nModule
    ],
    declarations: [
        ChartSecurityInputComponent,
        SecurityInputModComponent,
        SecurityAutocompleteModDirective,
        SecurityAutocompleteListModComponent
    ],
    exports: [
        ChartSecurityInputComponent
    ]
})
export class ChartSecurityInputModule {}
